import { useMutation } from "@tanstack/react-query";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DCSQueryClient } from "../../../../queryClient";
import { SectionHeader } from "../../../../components/SectionHeader/SectionHeader";
import { useToast } from "../../../../Providers/ToastProvider";
import { requests } from "../../../../services/http-common";
import { IClient } from "../Client.model";
import { ClientForm } from "../ClientForm/ClientForm";
import { useKeycloakContext } from "../../../../keycloak";

type ClientEditProps = {
  isOwn?: boolean;
};

export const ClientEdit = ({ isOwn }: ClientEditProps) => {
  let { clientId } = useParams<{ clientId: string }>();

  const navigate = useNavigate();
  const { show } = useToast();

  const keycloakContexxt = useKeycloakContext();
  const subId = keycloakContexxt.keycloak?.tokenParsed?.sub;

  if (isOwn) {
    clientId = subId;
  }

  const updateEmployee = useMutation({
    mutationFn: (newClient: Omit<IClient, "clientId">) => {
      return requests.put(`/client/${clientId}`, newClient);
    },
    onSuccess: () => {
      show({ detail: "Client was updated successfully !" });
      navigate(isOwn ? "/profile" : "/sales/client");
      DCSQueryClient.invalidateQueries({ queryKey: ["client-list"] });
    },
    onError: (error: any) => {
      show({
        severity: "error",
        detail: error.response?.data?.error?.message || "Something went wrong ",
      });
    },
  });

  return (
    <>
      <SectionHeader showBackButton={isOwn} title="Edit client" />
      <ClientForm
        onSubmit={updateEmployee.mutate}
        clientId={clientId}
        isEditForm
        isPending={updateEmployee.isLoading}
      />
    </>
  );
};
